module.exports = __webpack_public_path__ + "static/File-09edc88b4e5e7b02a10ed63c4320f5c7.png";